module.exports = __webpack_public_path__ + "static/media/orgulho.65736411.png";